import { configure } from "../../config/app";

export const isAuthorized = () =>  localStorage.getItem(configure.StorageKey.Vendor) !== null;
export const hasSelectedStore = () =>  localStorage.getItem(configure.StorageKey.CurrentStore) !== null;
export const getIdentity = (key) => JSON.parse(localStorage.getItem(configure.StorageKey.Vendor))[key];
export const getCurrentStore = () => JSON.parse(localStorage.getItem(configure.StorageKey.CurrentStore));